/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Settings`)
};

const zh_hans1_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理设置`)
};

const zh_hant1_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理設定`)
};

const fr_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les paramètres`)
};

const de_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen verwalten`)
};

const ja_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を管理`)
};

const ko_button_manage_settings = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정 관리`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const button_manage_settings = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.button_manage_settings(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("button_manage_settings", locale)
	if (locale === "en") return en_button_manage_settings(inputs)
	if (locale === "zh-Hans") return zh_hans1_button_manage_settings(inputs)
	if (locale === "zh-Hant") return zh_hant1_button_manage_settings(inputs)
	if (locale === "fr") return fr_button_manage_settings(inputs)
	if (locale === "de") return de_button_manage_settings(inputs)
	if (locale === "ja") return ja_button_manage_settings(inputs)
	return ko_button_manage_settings(inputs)
};